<template>
  <div
    class="AboutUs"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <div class="image">
      <div class="text eng_text">About Us</div>
    </div>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">About Us</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="about">
      <div class="section">
        <div class="title eng_title">About Us</div>
        <div
          class="content eng_content wow animate__animated animate__fadeInDown"
        >
          <p>
            Regong art refers to the folk traditional art originating from the
            Tongren area of Huangnan Tibetan Autonomous Prefecture in Qinghai
            Province. It was included in the first batch of national intangible
            cultural heritage list (2006), the representative list of human
            intangible cultural heritage works (2009), and selected for the
            first batch of national traditional craft revitalization directory
            (2018). Regong art is a folk art that integrates multiple ethnic
            groups such as Tibetans, Hans, and Tu people, and has been inherited
            for hundreds of years in the cultural environment of local temples
            and communities, gradually forming distinct regional
            characteristics. Its forms include Thangka (Tibetan scroll painting),
            pile embroidery, murals, clay sculptures, architectural color
            paintings, and other types. With rich and unique techniques and
            exquisite skills, it vividly depicts the natural scenery, historical
            stories, and social customs of the Qinghai Tibetan area, standing
            out in the field of Chinese folk art.
          </p>
          <p>
            Our chairman once stressed that “To promote the systematic
            protection of the cultural heritage of the Yellow River, we must
            cherish the precious heritage left by our ancestors.” Thangka art is
            the crystallization of the long-term development of Qinghai's ethnic
            culture and an important part of the Yellow River culture, with a
            wide-ranging impact nationally and even globally. With the passage
            of time, the protection of intangible cultural heritage is not only
            about traditional inheritance but also increasingly focused on
            innovative inheritance, promotion, and dissemination.
          </p>
          <p>
            The exhibition of Rebgong art works and the customized cultural and creative products website are supported by the National Natural Science Foundation project 'Key Technology Research on High-Quality Construction of Thangka Mural Digital Resources Based on Semi-Interaction' (62262056) and the Qinghai Province Key R&D and Achievement Transformation Project 'Research and Application of Key Technologies for Intelligent Extraction and Generation of Rebgong Art Elements' (2021-GX-111). This platform aims to focus on the protection and inheritance of Rebgong art, with the high-quality construction of Thangka mural digital resources as the core foundation, by using technologies like image processing, computer vision, and deep learning to carry out research on the semi-interactive high-quality construction technology of Thangka murals and key technologies for intelligent extraction and generation of Rebgong art elements. Through the website, app, cultural and creative design, and both online and offline promotion, it seeks to promote and spread Rebgong art, showcasing the unique charm of ethnic culture.
          </p>
          <p>
            The leading unit of this project is Qinghai Normal University, with
            cooperation from Hefei University of Technology and Qinghai Zumu
            Yalu Digital Technology Co. Ltd. The project director is Xiaojuan
            Zhang, who is a professor at Qinghai Normal University and director
            of the Qinghai Provincial Intangible Cultural Heritage Research
            Base. Other key members include Zhabu (former vice principal of
            Qinghai Normal University); Niangben (director of the Qinghai
            Non-Material Heritage Research Institute, a national representative
            inheritor of Regong Arts and Crafts, and a Chinese arts and crafts
            master); Anshu Hu (responsible for Tibetan cultural digital
            engineering at Zumu Yalu Digital Technology Co. Ltd. and at Wuhan
            University of Technology); Yang Zhao, Li Cao, and Lin Li (associated
            professors at Hefei University of Technology). The project team
            deeply experienced the profound love and appreciation that the local
            government,community, organizations, artists, apprentices, and
            ordinary people had for Regong art during the process of
            implementing the project. They also keenly felt the unique charm of
            Regong culture's exquisite skills and long-standing history. The
            project team sincerely hopes that digital technology can make Regong
            art more accessible to the public, enabling it to better integrate
            into modern cultural and creative product trends, and receive more
            effective promotion and inheritance.
          </p>
          <p>
            “Rengong”, which means “the golden valley where dreams come true”.
          </p>
        </div>
        <div class="images wow animate__animated animate__fadeInDown">
          <img src="../../assets/news/about.png" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="AboutUs" v-else-if="this.language == 'en'">
    <div class="image">
      <div class="text za_text">ང་ཚོའི་སྐོར།</div>
    </div>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>></span>
          <span class="color"> ང་ཚོའི་སྐོར།</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="about">
      <div class="section">
        <div class="title">ང་ཚོའི་སྐོར།</div>
        <div
          class="content za_content wow animate__animated animate__fadeInDown"
        >
          <p>
            རེབ་གོང་སྒྱུ་རྩལ་ཞེས་པ་ནི་མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་བོད་རིགས་རང་སྐྱོང་ཁུལ་རེབ་གོང་ས་ཁུལ་ནས་དར་བའི་དམངས་ཁྲོད་ཀྱི་སྲོལ་རྒྱུན་མཛེས་རྩལ་ཞིག་རེད། རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ཤུལ་བཞག་གི་མིང་ཐོ་ཁག་དང་པོ(2006)དང་།  མཉམ་འབྲེལ་རྒྱལ་ཚོགས་སློབ་གསོ་ཚན་རིག་རིག་གནས་རྩ་འཛུགས་ཀྱི་མིའི་རིགས་ཀྱི་གཟུགས་མེད་རིག་གནས་ཤུལ་བཞག་གི་མཚོན་བྱེད་བརྩམས་ཆོས་ཀྱི་མིང་ཐོའི་ནང་བཙུད（2009）ཡོད།  ད་དུང་རྒྱལ་ཁབ་ཀྱི་སྲོལ་རྒྱུན་ལག་ཤེས་བཟོ་རྩལ་དར་རྒྱས་ཀྱི་དཀར་ཆག་ཁག་དང་པོའི་ནང་ལའང་བཙུད（2018）ཡོད་པ་རེད། རེབ་གོང་སྒྱུ་རྩལ་ནི་བོད་རྒྱ་ཧོར་གསུམ་གྱི་མི་རིགས་མང་པོའི་ཐུན་མོང་གི་ཤེས་རིག་ལས་བྱུང་བའི་དམངས་ཁྲོད་སྒྱུ་རྩལ་ཞིག་ཡིན་པ་དང་། ས་གནས་དེ་གའི་དགོན་གྲོང་རིག་གནས་ཀྱི་ཁོར་ཡུག་ཏུ་ལོ་ངོ་བརྒྱ་ཕྲག་ཁ་ཤས་རིང་རྒྱུན་འཛིན་བྱས་པ་བརྒྱུད་ནས་ས་གནས་ཀྱི་ཁྱད་ཆོས་མངོན་གསལ་དོད་པོ་ཞིག་རིམ་བཞིན་ཆགས་ཡོད། དེ་ལ་རྣམ་པའི་ཆ་ནས་ཐང་ག་་དང་། འཚེམ་དྲུབ། ལྡེབས་རིས། འཇིམ་བཟོས། རྩིག་རིས་སོགས་རིགས་སྣ་ཚོགས་ཡོད་ཅིང་། སྣ་མང་ཕུན་སུམ་ཚོགས་པའི་མཚོན་ཚུལ་དང་ཞིབ་ཚགས་པའི་ལག་ཤེས་ལ་བརྟེན་ནས་མཚོ་སྔོན་བོད་རིགས་ས་ཁུལ་གྱི་རང་བྱུང་མཛེས་ལྗོངས་དང་། ལོ་རྒྱུས་ཀྱི་གནས་ཚུལ། སྤྱི་ཚོགས་ཀྱི་ཡུལ་སྲོལ་གོམས་གཤིས་བཅས་གསོན་ཉམས་དོད་པོས་མཚོན་པར་བྱས་ཡོད་པས། ཀྲུང་གོའི་དམངས་ཁྲོད་སྒྱུ་རྩལ་གྱི་ཁྱབ་ཁོངས་སུ་ཐུན་མོང་མ་ཡིན་པའི་ཁྱད་ཆོས་མངའ་བ་ཞིག་གོ
          </p>
          <p>
            སྤྱི་ཁྱབ་ཧྲུའུ་ཅི་ཞི་ཅིན་ཕིན་གྱིས་རྨ་ཆུའི་འབབ་རྒྱུད་ཀྱི་སྣོད་བཅུད་སྲུང་སྐྱོབ་དང་སྤུས་ཚད་མཐོ་བའི་འཕེལ་རྒྱས་ཀྱི་བཞུགས་མོལ་ཚོགས་འདུའི་ཐོག“རྨ་ཆུའི་རིག་གནས་ཤུལ་བཞག་ལ་བརྒྱུད་རིམ་ལྡན་པའི་ངང་སྲུང་སྐྱོབ་བྱ་རྒྱུར་སྐུལ་འདེད་བཏང་ནས་མེས་པོས་ང་ཚོར་བཞག་པའི་རྩ་ཆེའི་ཤུལ་བཞག་སྲུང་སྐྱོང་ཡག་པོ་བྱེད་དགོས”ཞེས་ནན་བཤད་གནང་བ་རེད། རེབ་གོང་སྒྱུ་རྩལ་ནི་མཚོ་སྔོན་གྱི་མི་རིགས་རིག་གནས་ཡུན་རིང་འཕེལ་རྒྱས་སུ་སོང་བའི་ཉིང་བཅུད་དང་རྨ་ཆུའི་རིག་གནས་ཀྱི་གྲུབ་ཆ་གལ་ཆེན་ཞིག་ཡིན་པས་རྒྱལ་ཡོངས་དང་ཐ་ན་འཛམ་གླིང་ཡོངས་སུ་ཤུགས་རྐྱེན་ཆེན་པོ་ལྡན། དུས་རབས་འཕེལ་རྒྱས་ཀྱི་འགྲོས་དང་བསྟུན་ནས་གཟུགས་མེད་རིག་གནས་ཤུལ་བཞག་སྲུང་སྐྱོབ་བྱ་རྒྱུ་དེ་ནི་སྲོལ་རྒྱུན་རྒྱུན་འཛིན་བྱེད་པ་ཙམ་དུ་མ་ཟད། གསར་གཏོད་རང་བཞིན་གྱིས་བཅོས་བསྒྱུར་དང་གསར་བཟོ་རང་བཞིན་གྱིས་འཕེལ་རྒྱས་སུ་གཏོང་རྒྱུ་ནི་་དེ་བས་ཀྱང་གལ་ཆེན་དུ་གྱུར་ཡོད།
          </p>
          <p>
            རེབ་གོང་སྒྱུ་རྩལ་བརྩམས་ཆོས་འགྲེམས་སྟོན་དང་རིག་གཏོད་ཐོན་རྫས་གཏན་སྲོལ་ཅན་གྱི་དྲ་ཚིགས་ལ་མཚོ་སྔོན་ཞིང་ཆེན་གྱི་གཙོ་གནད་ཞིབ་འཇུག་གསར་སྤེལ་དང་གཞན་སྒྱུར་ལས་གཞི“རེབ་གོང་སྒྱུ་རྩལ་གཞི་རྒྱུ་རིག་ནུས་བསྡུ་ལེན་དང་གྲུབ་པའི་འགག་རྩའི་ལག་རྩལ་ཞིབ་འཇུག་དང་བེད་སྤྱོད（2021-GX-111）”ཀྱི་རྒྱབ་སྐྱོར་དང་རོགས་སྐྱོར་ཐོབ་ཡོད་པ་རེད། ལས་གཞི་འདིའི་དམིགས་ཡུལ་ནི་རེབ་གོང་སྒྱུ་རྩལ་སྲུང་སྐྱོབ་དང་རྒྱུན་འཛིན་བྱ་རྒྱུར་དམིགས་ནས་པར་རིས་ཐག་གཅོད་དང་། རྩིས་འཁོར་མིག་ཚོར། གཏིང་ཟབ་སློབ་སྦྱོང་སོགས་ཀྱི་ལག་རྩལ་སྤྱད་དེ་རེབ་གོང་སྒྱུ་རྩལ་གཞི་རྒྱུ་ལ་རིག་ནུས་བསྡུ་ལེན་དང་གྲུབ་པའི་འགག་རྩའི་ལག་རྩལ་ཞིབ་འཇུག་བྱས་ནས་དྲ་ཚིགས་དང་། སུའེ་ཙེར། རིག་གཏོད་ཇུས་འགོད། དྲ་ཐོག་དྲ་ཕྱིའི་ཁྱབ་གདལ་སོགས་ཀྱི་བྱ་ཐབས་སྣ་ཚོགས་བརྒྱུད་ནས་རེབ་གོང་སྒྱུ་རྩལ་དྲིལ་སྒྲོག་དང་བརྒྱུད་སྤེལ་བྱས་ཏེ་མི་རིགས་རིག་གནས་ཀྱི་ཐུན་མོང་མ་ཡིན་པའི་ཡིད་དབང་འཕྲོག་ཤུགས་མངོན་པར་བྱ་རྒྱུ་དེ་ཡིན།
          </p>
          <p>
            ལས་གཞི་འདིའི་འགོ་ཁྲིད་ལས་ཁུངས་ནི་མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་དང་། མཉམ་ལས་ལས་ཁུངས་ནི་ཧོ་ཧྥེ་བཟོ་ལས་སློབ་ཆེན་དང་མཚོ་སྔོན་ཀྲུའུ་མུའུ་ཡ་ལུའུ་ཨང་ཀིའི་ཚན་རྩལ་ཚད་ཡོད་ཀུང་སི་ཡིན། ལས་གཞི་འདིའི་འགན་འཁུར་པ་ནི་དགེ་རྒན་ཀྲང་ཞའོ་ཅོན（མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་གྱི་དགེ་རྒན་ཆེན་མོ་དང་། མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ཤུལ་བཞག་ཞིབ་འཇུག་གནས་གཞིའི་ཀྲུའུ་རིན）ཡིན་ལ།  ལས་གཞི་འདིའི་ཁོངས་མི་གཙོ་བོ་ནི་དགེ་རྒན་ཆེན་མོ་རྒྱ་ཡེ་བཀྲ་བྷོ（མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་གྱི་སློབ་སྤྱི་གཞོན་པ་ཟུར་པ་དང་བོད་རིག་པའི་ཆེད་མཁས་པ།）དང་། དགེ་རྒན་སྙིང་འབུམ།（མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན་གྱི་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ཤུལ་བཞག་ཞིབ་འཇུག་གླིང་གི་གླིང་སྤྱི། མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་བོད་རིགས་རང་སྐྱོང་ཁུལ་རེབ་གོང་ལྷ་རིས་གླིང་གི་གླིང་སྤྱི། རེབ་གོང་སྒྱུ་རྩལ་གྱི་རྒྱལ་ཁབ་རིམ་པའི་རྒྱུན་འཛིན་པ། ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རིས་སློབ་དཔོན་ཆེན་མོ།）དང་།  དགེ་རྒན་ཧུའུ་ཨན་ཧྲུའུ།（ཀྲུའུ་མུའུ་ཡ་ལུའུ་ཨང་ཀིའི་ཚན་རྩལ་ཚད་ཡོད་ཀུང་སི་དང་། ཝུའུ་ཧན་རང་རྩིས་སློབ་ཆེན་གྱི་བོད་ཀྱི་རིག་གནས་གྲངས་སྒྱུར་ལས་གྲྭའི་འགན་འཁུར་པ།）བཅས་དང་། དགེ་རྒན་ཀྲའོ་དབྱང་དང་། ཚའོ་ལི། ལིས་ལིན།（ཧོ་ཧྥེའི་བཟོ་ལས་སློབ་ཆེན་གྱི་དགེ་རྒན་ཆེན་མོ་གཞོན་པ།）བཅས་དང་། དེ་བཞིན་ལས་གཞིའི་ལས་སྡེ་ཚན་གསུམ་ནས་ཡོང་བའི་དགེ་རྒན་དང་། ཇུས་འགོད་པ། སློབ་མ་བཅས་ཡིན། ལས་གཞི་ཚོགས་པས་ལས་གཞི་ལག་བསྟར་བྱེད་པའི་བརྒྱུད་རིམ་ཁྲོད་ས་གནས་ས་གནས་དེ་གའི་སྲིད་གཞུང་དང་། མཐུན་ཚོགས། ཁེ་ལས། རྒྱུན་འཛིན་པ། སྒྱུ་རྩལ་པ། རི་མོ་བ། སློབ་མ་བཅས་དང་དེ་བཞིན་མང་ཚོགས་དཀྱུས་མ་རེ་རྣམས་ཀྱིས་རེབ་གོང་སྒྱུ་རྩལ་ལ་བཅངས་པའི་དགའ་ཞེན་དང་གཅེས་སེམས་ལ་ཚོར་བ་ཟབ་མོ་སྐྱེས་པ་དང་། རེབ་གོང་རིག་གནས་ཀྱི་ཞིབ་ཅིང་ཕྲ་བའི་ལག་ཤེས་བཟོ་རྩལ་དང་ཡུན་རིང་བའི་ལོ་རྒྱུས་རྒྱུན་ལས་བྱུང་བའི་ཐུན་མོང་མ་ཡིན་པའི་ཡིད་དབང་འགུག་པའི་ནུས་པ་ཡིས་ང་ཚོ་ལ་མྱོང་བ་ཟབ་མོ་བསྩལ། ལས་གཞི་ཚོགས་པས་གྲངས་གཞི་ཅན་གྱི་ལག་རྩལ་གྱིས་རེབ་གོང་སྒྱུ་རྩལ་སྤྱི་དམངས་དང་ཉེ་བར་བཅར་ཐུབ་པ་དང་། དེ་ཉིད་དེང་རབས་རིག་གཏོད་ཐོན་རྫས་ཀྱི་རླབས་རྒྱུན་གྱི་གྲལ་དུ་ཚུད་པ་དང་སྔར་བས་ལེགས་པའི་སྒོ་ནས་དར་སྤེལ་དང་རྒྱུན་འཛིན་བྱེད་ཐུབ་པའི་རེ་བ་བཅངས་ཡོད།
          </p>
          <p>
            རེབ་གོང་།——ཕུགས་འདུན་མངོན་པར་འགྲུབ་སའི་གསེར་མདོག་གི་ཡུལ་གྲོང་།
          </p>
        </div>
        <div class="images wow animate__animated animate__fadeInDown">
          <img src="../../assets/news/about.png" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="AboutUs" v-else>
    <div class="image">
      <div class="text">关于我们</div>
    </div>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">关于我们</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="about">
      <div class="section">
        <div class="title">关于我们</div>
        <div class="content wow animate__animated animate__fadeInDown">
          <p>
            热贡艺术指发源于青海省黄南藏族自治州同仁地区的民间传统美术，被列入第一批国家级非物质文化遗产名录(2006)、人类非物质文化遗产代表作名录(2009)，并入选第一批国家传统工艺振兴目录(2018)。热贡艺术是一种融合了藏、汉、土等多民族的民间艺术，在当地寺社一体的文化环境下历经数百年传承，逐渐形成鲜明的地域特色，其形式包含唐卡(藏式卷轴画)、堆绣、壁画、泥塑、建筑彩绘等多种类型，以丰富独特的表现手法、细腻精湛的技艺，生动地描绘了青海藏区的自然风光、历史故事以及社会习俗，在中国民间艺术领域独树一帜。
          </p>
          <p>
            习近平总书记在黄河流域生态保护和高质量发展座谈会上讲话中强调:
            “要推进黄河文化遗产的系统保护，守好老祖宗留给我们的宝贵遗产。”热贡艺术是青海民族文化长期发展的结晶，是黄河文化的重要组成部分，在全国乃至全世界具有广泛影响。随着时代的发展，对非物质文化遗产的保护不仅是传统的继承，创造性转化、创新性发展显得更加重要。
          </p>
          <p>
            热贡艺术作品展览及文创产品定制化网站得到国家自然基金项目“基于半交互的唐卡壁画数字资源高质量构建关键技术研究”（62262056）及青海省重点研发与成果转化项目“热贡艺术元素智能提取与生成关键技术研究及应用” (2021-GX-111) 共同支持资助。本平台旨在围绕热贡艺术的保护与传承，通过使用图像处理、计算机视觉、深度学习等技术，开展半交互式唐卡壁画高质量数字资源构建技术和热贡艺术元素的智能提取与生成关键技术研究，通过网站、APP、文创设计、线下线上推广等各种方式宣传、传播热贡艺术，彰显民族文化的独特魅力。
          </p>
          <p>
            本项目的牵头单位为青海师范大学，合作单位为合肥工业大学及青海珠穆雅鲁数字科技有限公司，项目负责人为张效娟老师（青海师范大学教授、青海省非物质文化遗产研究基地主任），项目主要成员有扎布老师（青海师范大学原副校长、藏学专家），娘本老师（青海师范大学省非遗研究院院长、青海黄南州热贡画院院长、热贡艺术国家级代表性传承人、中国工艺美术大师），胡桉澍老师（珠穆雅鲁数字科技有限公司、武汉理工大学藏文化数字化工程负责人），赵洋、曹力和李琳老师（合肥工业大学副教授），以及来自三家项目单位的学生与设计师。项目团队在项目执行的过程中，深切体会到当地政府、协会、企业、传承人艺术家、画师、学徒，以及普通民众对热贡艺术的热爱和珍视，深刻感受到热贡文化细腻精湛技艺与悠久历史传承的独特魅力。项目团队衷心希望数字化技术能让热贡艺术更贴近公众，使其更好的融入现代文创产品潮流，得到更加有效的弘扬与传承。
          </p>
          <p>“热贡”——梦想成真的金色谷地。</p>
        </div>
        <div class="images wow animate__animated animate__fadeInDown">
          <img src="../../assets/news/about.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss" scoped>
.AboutUs {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .image {
    position: relative;
    background: url("../../assets/newImage/swiper/4.jpg") no-repeat center
      center;
    background-size: 100% 100%;
    height: 580px;
    .text {
      text-align: center;
      width: 2.5rem;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      color: #fff;
      font-size: 82px;
      font-family: "fangzang";
    }
    .za_text {
      font-size: 90px;
    }
    .eng_text {
      font-family: "Times New Roman", Times, serif;
      font-size: 80px;
    }
  }
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .about {
    .section {
      .title {
        text-align: center;
        font-size: 30px;
        font-family: "fangzang";
        padding: 40px 0;
      }
      .eng_title {
        font-family: "Times New Roman", Times, serif;
      }
      .content {
        p {
          text-indent: 2em;
          letter-spacing: 1px;
          line-height: 1.5;
          font-size: 16px;
          margin-bottom: 16px;
          text-align: justify;
        }
      }
      .eng_content {
        p {
          text-indent: 0;
        }
      }
      .za_content {
        p {
          font-size: 20px;
        }
      }
      .images {
        padding: 40px 0;
        img {
          width: 100%;
          height: 320px;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .AboutUs {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .image {
      background: url("../../assets/newImage/mobile/index/4.jpg") no-repeat
        center center;
      background-size: cover;
      height: 3.4rem;
      position: relative;
      .text {
        font-size: 0.5rem !important;
      }
      .za_text {
        font-size: 0.3rem !important;
      }
    }
    .exhibitionTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .cloudLeft {
        position: absolute;
        top: 1%;
        right: 0;
        width: 1.25rem;
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .about {
      .section {
        .title {
          font-size: 0.45rem;
          padding: 0.5rem 0;
        }
        .content {
          height: 12rem;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE 10+ */
          overflow: scroll;
          p {
            letter-spacing: 0;
            line-height: 0.6rem;
          }
        }
        .content::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .images {
          padding: 0.5rem 0 0.7rem 0;
          img {
            width: 100%;
            height: 2.5rem;
          }
        }
      }
    }
    .mobilecloudLeft {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 1.25rem;
    }
  }
}
</style>
